export const CONFIG = {
  // Staging
  // BASE_URL: 'https://api.test.rooster.money/api',
  // Local
  // BASE_URL: 'http://localhost:3000/api',
  // Production
  BASE_URL: 'https://api.rooster.money/api',
  RMCLID_ENDPOINT: '/attribution/rmclid',
};
